import type { SxProps, Theme } from "@mui/material";
import { MIN_TAP_TARGET } from "../responsive";

/** SP 用に文字サイズを小さくする（一覧画面向け）。 */
export const listCompactSx: SxProps<Theme> = {
  // PageTitle は SP で 20px（body1 の縮小指定より優先させる）
  "& .MuiTypography-root.PageTitle": { fontSize: "20px" },
  "& .MuiTypography-h4": { fontSize: "1.25rem" },
  "& .MuiTypography-h5": { fontSize: "1.15rem" },
  "& .MuiTypography-h6": { fontSize: "1rem" },
  "& .MuiTypography-subtitle1": { fontSize: "0.92rem" },
  "& .MuiTypography-body1": { fontSize: "0.875rem" },
  "& .MuiTypography-body2": { fontSize: "0.82rem" },
  "& .MuiTypography-caption": { fontSize: "0.72rem" },
  "& .MuiButton-root": { fontSize: "0.82rem", py: 0.4 },
  // 文字・paddingを縮めてもタップ領域は確保（TapExpanded は ::after で拡張済みの小ボタン）
  "& .MuiButton-root:not(.TapExpanded)": { minHeight: MIN_TAP_TARGET },
  "& .MuiChip-root": { height: 22, fontSize: "0.75rem" },
  "& .MuiToggleButton-root": { fontSize: "0.78rem", py: 0.4 },
  // iOS Safari は 16px 未満だとフォーカス時にズームするため入力値は 16px
  "& .MuiInputBase-input": { fontSize: "16px" },
  "& .MuiInputLabel-root": { fontSize: "0.875rem" },
};

/** SP 用に文字サイズをさらに小さくする（情報量の多い詳細画面向け）。 */
export const detailCompactSx: SxProps<Theme> = {
  // PageTitle は SP で 20px（body1 の縮小指定より優先させる）
  "& .MuiTypography-root.PageTitle": { fontSize: "20px" },
  "& .MuiTypography-h5": { fontSize: "1.05rem" },
  "& .MuiTypography-h6": { fontSize: "0.95rem" },
  "& .MuiTypography-subtitle1": { fontSize: "0.85rem" },
  "& .MuiTypography-body1": { fontSize: "0.8rem" },
  "& .MuiTypography-body2": { fontSize: "0.75rem" },
  "& .MuiTypography-caption": { fontSize: "0.68rem" },
  "& .MuiButton-root": { fontSize: "0.75rem", py: 0.4 },
  // 文字・paddingを縮めてもタップ領域は確保（TapExpanded は ::after で拡張済みの小ボタン）
  "& .MuiButton-root:not(.TapExpanded)": { minHeight: MIN_TAP_TARGET },
  "& .MuiChip-root": { height: 20, fontSize: "0.68rem" },
  "& .MuiTab-root": { fontSize: "0.75rem", minHeight: 36 },
  "& .MuiInputBase-input": { fontSize: "16px" },
  "& .MuiInputLabel-root": { fontSize: "0.8rem" },
};
